import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles({
  label: {
    fontSize: '14px',
    lineHeight: '1.5',
    color: '#444444',
  },
  requiredLabel: {
    height: '20px',
    fontSize: '14px',
    lineHeight: '1.5',
    fontWeight: 'bold',
    color: '#FF0000',
    marginTop: '24px',
  },
});

const RadioButtonListLabel = (props) => {
  const classes = useStyles();

  const { required, translatedLabel } = props;
  return required ? (
    <div className={classes.label}>
      {translatedLabel} <span className={classes.requiredLabel}>{'*'}</span>
    </div>
  ) : (
    <div className={classes.label}>{translatedLabel}</div>
  );
};

export default RadioButtonListLabel;
